// frontend/src/hooks/useTypewriter.js
import { useState, useEffect } from "react";

export function useTypewriter(text, { delay = 30 } = {}) {
  const [displayed, setDisplayed] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    if (!text) {
      setDisplayed("");
      setIsTyping(false);
      return;
    }
    setIsTyping(true);
    setDisplayed("");
    let i = 0;
    const iv = setInterval(() => {
      i++;
      setDisplayed(text.slice(0, i));
      if (i >= text.length) {
        clearInterval(iv);
        setIsTyping(false);
      }
    }, delay);
    return () => clearInterval(iv);
  }, [text, delay]);

  return { displayed, isTyping };
}
